import { render, staticRenderFns } from "./ScaniaDashboard.vue?vue&type=template&id=3467cd51&"
import script from "./ScaniaDashboard.vue?vue&type=script&lang=js&"
export * from "./ScaniaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports